import type { ServiceItem } from '@/cms/fields/types/checkout-page'
import { isEmpty } from 'ramda'
import * as React from 'react'
import { useIntl } from '@/intl'
import { CheckoutSection } from '@/scopes/checkout/components/CheckoutSection'
import { getIconForService } from '@/scopes/checkout/components/ServiceIcon'
import { useSendAncillaryAvailable } from '@/scopes/checkout/domain/analytics/useSendAncillaryAvailable'
import { useService } from '@/scopes/checkout/domain/hooks'
import { ServiceType } from '@/scopes/checkout/domain/types'
import { BridgeOptionRow } from './BridgeOptionRow'
import styles from './BridgeService.module.css'
import { bridgeOptionsSelector } from './selectors'

export function BridgeService({ item }: { item: ServiceItem }) {
  const intl = useIntl()
  const { componentTitle, componentDescription, popupTitle, popupDescription, popupReadMoreLabel } = item
  const { service } = useService(ServiceType.Bridge)
  useSendAncillaryAvailable(service, 'selectBridge')

  if (!service)
    return null

  const { options, participants } = service

  if (isEmpty(options) || isEmpty(participants))
    return null

  const bridgeOptions = bridgeOptionsSelector(service)

  return (
    <CheckoutSection
      title={componentTitle || intl.formatMessage({ id: 'checkout_steps_ancillaries_bridge_title' })}
      description={componentDescription}
      glyph={getIconForService(ServiceType.Bridge)}
      moreInformationTitle={popupTitle}
      moreInformationDescription={popupDescription}
      moreInformationReadMoreLabel={popupReadMoreLabel}
    >
      <div className={styles.content}>
        {bridgeOptions.map(option => (
          <BridgeOptionRow
            key={option.id}
            option={option}
          />
        ))}
      </div>
    </CheckoutSection>
  )
}
